<template>   
    <b-row class="slide-body">
        <b-col cols="2">
            <b-img @click="$router.go(-1)" left src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img>
        </b-col>

        <b-col cols="8">
            <b-row align-h="center" class="pt-3 pb-3">   
                <h1 style="color:#ffffff"><strong>{{ $t('slide33.text1') }}</strong></h1>
            </b-row>
            <b-row class="pt-3">
                <b-col cols="6">
                   <b-button @click="downloadWithVueResource($t('slide33.text8'),$t('slide33.text9'))" variant="warning"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text2') }}</strong></h3></b-button>
                </b-col>
                <b-col cols="6">
                    <b-button v-if="showComEsMunta" @click="showComEsMunta=false" variant="warning"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text3') }}</strong></h3></b-button>
                    <b-button class="mr-1" v-if="!showComEsMunta" @click="downloadWithVueResource('/documents/Capsa.pdf','Capsa.pdf')" variant="success"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text6') }}</strong></h3></b-button>
                    <b-button v-if="!showComEsMunta" @click="downloadWithVueResource('/documents/Fresadora.pdf','Fresadora.pdf')" variant="success"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text7') }}</strong></h3></b-button>
                </b-col>
            </b-row>

            <b-row align-h="center" class="pt-3 pb-3">   
                <h1 style="color:#ffffff"><strong>{{ $t('slide33.text4') }}</strong></h1>
            </b-row>
            <b-row class="pt-3">
                <b-col cols="4">
                    <b-row align-h="center">
                        <b-img  src="@/images/file_stl_1.png" fluid></b-img>
                    </b-row>
                    <b-row align-h="center">
                        <b-button @click="downloadWithVueResource('/documents/file_1.stl','file_1.stl')" variant="success"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text5') }}</strong></h3></b-button>
                    </b-row>
                </b-col>
                <b-col cols="4">
                    <b-row align-h="center">
                        <b-img  src="@/images/file_stl_2.png" fluid></b-img>
                    </b-row>
                    <b-row align-h="center">
                        <b-button @click="downloadWithVueResource('/documents/file_2.stl','file_2.stl')" variant="success"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text5') }}</strong></h3></b-button>
                    </b-row>
                </b-col>
                <b-col cols="4">
                    <b-row align-h="center">
                        <b-img  src="@/images/file_stl_3.png" fluid></b-img>
                    </b-row>
                    <b-row align-h="center">
                        <b-button @click="downloadWithVueResource('/documents/file_3.stl','file_3.stl')" variant="success"><h3 style="color:#ffffff"><strong>{{ $t('slide33.text5') }}</strong></h3></b-button>
                    </b-row>
                </b-col>
            </b-row>
            
        </b-col>

        <b-col cols="2">
            
        </b-col>
    </b-row>  
</template>


<script>
import {mapState} from 'vuex';

export default { 
    props:['lang'],       
    data(){
        return {
            showComEsMunta: true
        }
    },
    computed: {
        ...mapState(['showMenu']),        
    },
    methods:{
        forceFileDownload(response,fileName){
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
        },   
        downloadWithVueResource(url,fileName) {     
            this.$http({
                method: 'get',
                url: url,
                responseType: 'arraybuffer'
            })
            .then(response => {                
                this.forceFileDownload(response,fileName) 
            })
            .catch(() => console.log('error occured'))        
        },
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',false);        
    } 
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;    
    } 

    img {
        max-width: 100%;
        height: auto;
    }

</style>